export default __webpack_public_path__ + "static/media/GHSI Manual on Corporate Governance.3feb30d1.pdf";